export default __webpack_public_path__ + "static/media/WMCJ-19552.08f23d5e.jpg";